import {getLang} from './helpers.js';

jQuery.validator.addMethod("phone", function(value, element) {
  return this.optional( element ) || /\+[0-9]{10,12}/.test(value);
}, 'Please, enter correct phone number');

// jQuery.validator.addMethod("customName", function(value, element) {
//   return this.optional( element ) || value.search(/[^а-яёА-ЯЁa-zA-Z.,-\s]/g) === -1;
// }, 'Name contains incorrect symbols');

// jQuery.validator.addMethod("customEmail", function(value, element) {
//   return this.optional( element ) || /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(value);
// }, 'Please enter a valid email address.');

if (getLang() == 'ru') {
    $.extend( $.validator.messages, {
        required: "Это поле необходимо заполнить.",
        remote: "Пожалуйста, введите правильное значение.",
        email: "Некорректный email",
        url: "Пожалуйста, введите корректный URL.",
        date: "Пожалуйста, введите корректную дату.",
        dateISO: "Пожалуйста, введите корректную дату в формате ISO.",
        number: "Пожалуйста, введите число.",
        digits: "Пожалуйста, вводите только цифры.",
        creditcard: "Пожалуйста, введите правильный номер кредитной карты.",
        equalTo: "Пожалуйста, введите такое же значение ещё раз.",
        extension: "Пожалуйста, выберите файл с правильным расширением.",
        maxlength: $.validator.format( "Пожалуйста, введите не больше {0} символов." ),
        minlength: $.validator.format( "Пожалуйста, введите не меньше {0} символов." ),
        rangelength: $.validator.format( "Пожалуйста, введите значение длиной от {0} до {1} символов." ),
        range: $.validator.format( "Пожалуйста, введите число от {0} до {1}." ),
        max: $.validator.format( "Пожалуйста, введите число, меньшее или равное {0}." ),
        min: $.validator.format( "Пожалуйста, введите число, большее или равное {0}." ),
        phone: $.validator.format('Введите корректный номер телефона'),
        // customName: $.validator.format('Имя содержит недопустимые символы'),
        // customName: $.validator.format('Пожалуйста, введите корректный адрес электронной почты.'),
        // customDate: $.validator.format('Пожалуйста, введите корректную дату в формате дд.мм.гггг'),
        // filesize: $.validator.format('Недопустимый размер файла. Прикрепите файл до 25 мб')
    });
}


// WEBPACK FOOTER //
// ./js/utils/forms.js